import React from "react";
import { ClockArrowDown } from "lucide-react";
import { Card, SearchInput, SegmentedControl, Table, Badge, TablePagination } from "../../../components/ui";

const ArrearTable = ({
  arrearSearch,
  setArrearSearch,
  arrearFilter,
  handleArrearFilterChange,
  searchedArrearList,
  paginatedArrearList,
  arrearPage,
  setArrearPage,
  totalArrearPages,
  ITEMS_PER_PAGE
}) => {
  return (
    <Card>
      <Card.Header
        title={
          <div className="flex items-center gap-2">
            <ClockArrowDown size={18} className="text-primary-500" />
            <span>Arrear Details</span>
          </div>
        }
        actions={
          <div className="flex flex-wrap items-center gap-3 w-full lg:w-auto">
            <SearchInput
              placeholder="Search customer..."
              value={arrearSearch}
              onChange={(e) => {
                setArrearSearch(e.target.value);
                setArrearPage(1);
              }}
            />
            
            <SegmentedControl
              value={arrearFilter}
              onChange={handleArrearFilterChange}
              options={[
                { value: "All", label: "All" },
                { value: "Pending", label: "Pending" },
                { value: "Received", label: "Received" },
              ]}
            />

            <span className="text-xs font-bold text-ink-700 bg-canvas px-2.5 py-1.5 rounded-lg border border-border whitespace-nowrap">
              {searchedArrearList.length} Found
            </span>
          </div>
        }
      />
      <Card.Body>
        <Table>
          <Table.Head>
            <tr>
              <Table.HeadCell>S.No</Table.HeadCell>
              <Table.HeadCell>Customer</Table.HeadCell>
              <Table.HeadCell>Due No</Table.HeadCell>
              <Table.HeadCell>Amount</Table.HeadCell>
              <Table.HeadCell>Status</Table.HeadCell>
            </tr>
          </Table.Head>
          <Table.Body>
            {paginatedArrearList.length > 0 ? (
              paginatedArrearList.map((arrear, index) => (
                <Table.Row key={index} status={arrear.received.toLowerCase() === "received" ? "received" : "rejected"}>
                  <Table.Cell>
                    {(arrearPage - 1) * ITEMS_PER_PAGE + index + 1}
                  </Table.Cell>
                  <Table.Cell className="font-medium">{arrear.customerName || "N/A"}</Table.Cell>
                  <Table.Cell className="font-medium">{arrear.dueNo || "0"}</Table.Cell>
                  <Table.AmountCell>
                    {arrear.arrearTotal || 0}
                  </Table.AmountCell>
                  <Table.Cell>
                    <Badge variant={arrear.received.toLowerCase() === "received" ? "success" : "danger"} dot>
                      {arrear.received || "Unknown"}
                    </Badge>
                  </Table.Cell>
                </Table.Row>
              ))
            ) : (
              <Table.EmptyRow colSpan={5} message="No arrear details available" />
            )}
          </Table.Body>
        </Table>

        <TablePagination
          currentPage={arrearPage}
          totalPages={totalArrearPages}
          totalEntries={searchedArrearList.length}
          itemsPerPage={ITEMS_PER_PAGE}
          onPageChange={setArrearPage}
        />
      </Card.Body>
    </Card>
  );
};

export default ArrearTable;
